import { configureStore } from '@reduxjs/toolkit'
import { api } from './service/apislice'
import planReducer from '../helpers/reduxslice/index'

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    plan: planReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
})
